import { render, staticRenderFns } from "./purchase-history.vue?vue&type=template&id=419850c4&"
import script from "./purchase-history.js?vue&type=script&lang=ts&"
export * from "./purchase-history.js?vue&type=script&lang=ts&"
import style0 from "./purchase-history.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports